module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-form', {
    on: {
      "submit": _vm.authenticate
    }
  }, [_c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "3"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "6"
    }
  }, [_c('img', {
    attrs: {
      "title": _vm.$t('LNG_TITLE', this.lang),
      "alt": _vm.$t('LNG_TITLE', this.lang),
      "width": "200px",
      "src": require("../assets/img/logo.jpg")
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('LNG_WELCOME', _vm.lang)))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "4"
    }
  }, [_c('b-input-group', [_c('b-input-group-text', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('LNG_EMAIL', _vm.lang),
      "required": "",
      "autofocus": "",
      "autocapitalize": "off"
    },
    on: {
      "keydown": function($event) {
        return _vm.setErrorMessage('')
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-input-group', [_c('b-input-group-text', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-at"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('LNG_PASSWORD', _vm.lang),
      "required": "",
      "autofocus": "",
      "autocapitalize": "off"
    },
    on: {
      "keydown": function($event) {
        return _vm.setErrorMessage('')
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-3"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_LOGIN_BTN', _vm.lang)))])], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-3"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.recoverPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_RECOVER_PASSWORD', _vm.lang)))])], 1)], 1)], 1), _vm._v(" "), (_vm.errorMessage !== '') ? _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(_vm._s(this.errorMessage))])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d4225cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 876
// module chunks = 1